import { render, staticRenderFns } from "./ProductEntityRelationshipCard.vue?vue&type=template&id=da6eefa8"
import script from "./ProductEntityRelationshipCard.vue?vue&type=script&lang=js"
export * from "./ProductEntityRelationshipCard.vue?vue&type=script&lang=js"
import style0 from "./ProductEntityRelationshipCard.vue?vue&type=style&index=0&id=da6eefa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports